module.exports = __webpack_public_path__ + "static/media/ic-tags.a4742054.svg";